import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ICheckListSchema } from './interfaces';

export const getCheckListSchemaList = (data: IDynamicTableParams) => {
  return instance()
    .post<ICheckListSchema[]>('/calculatorTariff/checklist/schema/list', data)
    .then((response) => response.data);
};

export const getCheckListSchemaAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/calculatorTariff/checklist/schema/availableColumns')
    .then((response) => response.data);
};

export const getCheckListSchemaAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/calculatorTariff/checklist/schema/availableGroupColumns')
    .then((response) => response.data);
};

export const loadCheckListSchema = (checklistSchemaId: number) => {
  return instance()
    .get<ICheckListSchema>(`/calculatorTariff/checklist/schema/${checklistSchemaId}/load`)
    .then((response) => response.data);
};

export const createCheckListSchema = (checkListSchema: ICheckListSchema) => {
  return instance()
    .post<ICheckListSchema>(`/calculatorTariff/checklist/schema/${checkListSchema.formType}/create`, checkListSchema)
    .then((response) => response.data);
};

export const updateCheckListSchema = (checkListSchema: ICheckListSchema) => {
  return instance()
    .post<ICheckListSchema>(
      `/calculatorTariff/checklist/schema/${checkListSchema.checklistSchemaId}/update`,
      checkListSchema,
    )
    .then((response) => response.data);
};

export const publishCheckListSchema = (checkListSchema: ICheckListSchema) => {
  return instance()
    .post<ICheckListSchema>(
      `/calculatorTariff/checklist/schema/${checkListSchema.checklistSchemaId}/updatePublic`,
      checkListSchema,
    )
    .then((response) => response.data);
};
